export default "__VITE_ASSET__0a734824__"